import styled from 'styled-components';
export const CalendarBase = styled.div.attrs({
    className: 'calendar',
}) `
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;

  background: var(--color-background);
  box-shadow: var(--elevation-overlay);
`;
